import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../style.css';

function AboutUs() {
  return (
    <div className="page-wrapper">
      <Helmet>
        <title>About Us | Culturlingua Spanish School — Tlaquepaque</title>
        <meta name="description" content="Learn Spanish in Tlaquepaque, Guadalajara with certified teachers. Immersive Spanish classes for all levels." />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Spanish School</div>
        <h1>About Us</h1>
        <p>Your place to learn Spanish immersed in Mexican culture in beautiful Tlaquepaque.</p>
      </div>

      <section style={{background:'var(--cream)', padding:'80px 48px'}}>
        <div style={{maxWidth:'800px', margin:'0 auto', display:'flex', flexDirection:'column', gap:'32px'}}>

          <div style={{background:'white', borderRadius:'20px', padding:'40px', boxShadow:'0 2px 16px rgba(0,0,0,0.06)'}}>
            <div className="section-tag">Who we are</div>
            <h2 className="section-headline" style={{fontSize:'1.8rem', marginBottom:'16px'}}>Learn Spanish in Tlaquepaque</h2>
            <p style={{color:'var(--muted)', lineHeight:'1.8', marginBottom:'16px'}}>
              Enjoy a break and study Spanish in Guadalajara with a tailor-made, personalized program suiting your personal education needs.
              Everybody learns differently, so let us help you gain confidence in speaking, reading and writing Spanish at your own pace and at your own level.
            </p>
            <p style={{color:'var(--muted)', lineHeight:'1.8'}}>
              Totally immerse yourself in an experience perfect to help you learn Spanish, whilst living and breathing the Mexican way of life.
              Take advantage of our homestay accommodation service, or stay in one of the many wonderful hotels in Tlaquepaque — a vibrant, yet quaint and picturesque corner of Guadalajara.
            </p>
          </div>

          <div style={{background:'white', borderRadius:'20px', padding:'40px', boxShadow:'0 2px 16px rgba(0,0,0,0.06)'}}>
            <div className="section-tag">The Experience</div>
            <h2 className="section-headline" style={{fontSize:'1.8rem', marginBottom:'16px'}}>Culture & Language Together</h2>
            <p style={{color:'var(--muted)', lineHeight:'1.8', marginBottom:'16px'}}>
              While staying here, meander through Tlaquepaque's beautiful cobbled streets and discover its famous artisanal handicrafts.
              Venture further into Guadalajara — the land of tequila and mariachi and Mexico's second largest city.
            </p>
            <p style={{color:'var(--muted)', lineHeight:'1.8'}}>
              Spanish classes can be taken in the school or if you prefer, our teachers are happy to teach Spanish while visiting cafes, museums or simply visiting the local market.
              Whether you want to study Spanish for fun, for business, or to simply immerse yourself in the culture, we will do our best to accommodate you.
            </p>
          </div>

          <div style={{display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:'20px'}}>
            {[
              ['🎯', 'Learn', 'Learn Spanish in a colonial and friendly environment in beautiful Tlaquepaque.'],
              ['🗣️', 'Language Exchange', 'Exchange language with students who want to learn your language.'],
              ['🎓', 'Qualified Teachers', 'All our teachers are qualified and experienced to teach Spanish.'],
              ['🌎', 'Cultural Activities', 'Enjoy the beautiful surroundings of Jalisco and learn about Mexican culture.'],
            ].map(([icon, title, desc]) => (
              <div key={title} style={{background:'var(--navy)', borderRadius:'16px', padding:'24px', color:'white'}}>
                <div style={{fontSize:'1.8rem', marginBottom:'12px'}}>{icon}</div>
                <div style={{fontFamily:'Fraunces, serif', fontWeight:'700', fontSize:'1.1rem', marginBottom:'8px'}}>{title}</div>
                <div style={{color:'rgba(255,255,255,0.6)', fontSize:'0.875rem', lineHeight:'1.6'}}>{desc}</div>
              </div>
            ))}
          </div>

          <div style={{textAlign:'center', display:'flex', gap:'16px', justifyContent:'center', flexWrap:'wrap'}}>
            <Link to="/Placement-Test" className="btn-glow">Take Placement Test →</Link>
            <Link to="/contacto" className="btn-outline" style={{color:'var(--navy)', border:'1.5px solid var(--navy)'}}>Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;
